import { css } from 'styled-components';

const mixins = {
  flexCenter: css`
    display: flex;
    justify-content: center;
    align-items: center;
  `,

  flexBetween: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,

  link: css`
    display: inline-block;
    text-decoration: none;
    text-decoration-skip-ink: auto;
    color: inherit;
    position: relative;
    transition: var(--transition);
    &:hover,
    &:active,
    &:focus {
      color: var(--green);
      outline: 0;
    }
  `,

  inlineLink: css`
    display: inline-block;
    text-decoration: none;
    text-decoration-skip-ink: auto;
    position: relative;
    transition: var(--transition);
    color: var(--green);
    &:hover,
    &:focus,
    &:active {
      color: var(--green);
      outline: 0;
      &:after {
        width: 100%;
      }
      & > * {
        color: var(--green) !important;
        transition: var(--transition);
      }
    }
    &:after {
      content: '';
      display: block;
      width: 0;
      height: 1px;
      position: relative;
      bottom: 0.37em;
      background-color: var(--green);
      transition: var(--transition);
      opacity: 0.5;
    }
  `,

  button: css`
    color: var(--green);
    background-color: transparent;
    border: 1px solid var(--green);
    border-radius: var(--border-radius);
    font-size: var(--fz-xs);
    font-family: var(--font-mono);
    line-height: 1;
    text-decoration: none;
    cursor: pointer;
    transition: var(--transition);
    padding: 1.25rem 1.75rem;

    &:hover,
    &:focus,
    &:active {
      background-color: var(--green-tint);
      outline: none;
    }
    &:after {
      display: none !important;
    }
  `,

  smallButton: css`
    color: var(--green);
    background-color: transparent;
    border: 1px solid var(--green);
    border-radius: var(--border-radius);
    padding: 0.75rem 1rem;
    font-size: var(--fz-xs);
    font-family: var(--font-mono);
    line-height: 1;
    text-decoration: none;
    cursor: pointer;
    transition: var(--transition);
    &:hover,
    &:focus,
    &:active {
      background-color: var(--green-tint);
      outline: none;
    }
    &:after {
      display: none !important;
    }
  `,

  bigButton: css`
    color: var(--green);
    background-color: transparent;
    border: 1px solid var(--green);
    border-radius: var(--border-radius);
    padding: 1.25rem 1.75rem;
    font-size: var(--fz-sm);
    font-family: var(--font-mono);
    line-height: 1;
    text-decoration: none;
    cursor: pointer;
    transition: var(--transition);
    &:hover,
    &:focus,
    &:active {
      background-color: var(--green-tint);
      outline: none;
    }
    &:after {
      display: none !important;
    }
  `,

  linkButton: css`background: none;
    border: none;
    padding: 0.2em 0.1em;
    margin: 0;

    font-family: var(--font-mono);
    font-size: var(--fz-md);
    color: var(--slate);
    cursor: pointer;
    position: relative;
    transition: var(--transition);
    text-decoration: none;

    &:hover,
    &:focus {
      color: var(--green);
      outline: 0;
      &:after {
        width: 100%;
      }
    }

    &:after {
      content: '';
      display: block;
      width: 0;
      height: 1.5px;
      position: absolute;
      bottom: -0.15em;
      left: 0;
      background-color: var(--green);
      transition: var(--transition);
      opacity: 0.6;
    }

    &.active {
      color: var(--green);
      font-weight: 600;
      &:after {
        width: 100%;
        opacity: 1;
      }
    }
  `,

  searchBar: css`
    margin-bottom: 35px;
    display: flex;
    justify-content: center;
    padding: 0 15px;

    input[type="text"], input[type="number"] {
      padding: 0.75rem 1rem;
      width: 100%;
      max-width: 550px;
      border: 1px solid var(--dark-slate);
      border-radius: var(--border-radius);
      font-size: var(--fz-sm);
      font-family: var(--font-mono);
      color: var(--lightest-slate);
      background-color: var(--light-navy);
      box-shadow: 0 10px 30px -15px var(--navy-shadow);
      transition: var(--transition);

      &:hover,
      &:focus {
        outline: none;
        border-color: var(--green);
        box-shadow: 0 20px 30px -15px var(--navy-shadow);
      }

      &::placeholder {
        color: var(--slate);
        opacity: 0.8;
      }
    }
  `,

  boxShadow: css`
    box-shadow: 0 10px 30px -15px var(--navy-shadow);
    transition: var(--transition);

    &:hover,
    &:focus {
      box-shadow: 0 20px 30px -15px var(--navy-shadow);
    }
  `,

  fancyList: css`
    padding: 0;
    margin: 0;
    list-style: none;
    font-size: var(--fz-lg);
    li {
      position: relative;
      padding-left: 30px;
      margin-bottom: 10px;
      &:before {
        content: '▹';
        position: absolute;
        left: 0;
        color: var(--green);
      }
    }
  `,

  resetList: css`
    list-style: none;
    padding: 0;
    margin: 0;
  `,
};

export default mixins;
